<template>
  <v-ons-page class="l-login">
    <div class="header text-center">
      <img :src="secundo_logo">
    </div>    
    <div class="loginZone">
      <div class="container">
        <p class="text-center">
          Entrez votre email afin que nous puissions vous envoyer votre mot de passe.<br>
          /<br>
          Vul uw e-mailadres in zodat we u uw wachtwoord kunnen sturen
        </p>
        <p><v-ons-input id="email" placeholder="Email" modifier="material" v-model="email"></v-ons-input></p>
        <v-ons-button @click="send_password">Envoyer / Sturen</v-ons-button>
        <v-ons-button @click="back">Retour / Terug</v-ons-button>
      </div>
    </div>
  </v-ons-page>
</template>

<script>
  import { EventBus } from '../EventBus.js';

  export default {
    data () {
      return {
        email: '',
        secundo_logo: secundo_logo
      };
    },
    methods: {
      send_password() {
        if(this.email != '') {
          axios
            .get('/users/send-password', {
              params: {
                'x-secundo-auth': 'ABC123',
                'email': this.email,
              }
            })
            .then(response => {
              if(response.data) {
                this.$ons.notification.toast('Mot de passe envoyé / Wachtwoord verzonden', {timeout: 5000});
                EventBus.$emit('navigate', 'Login');
              }
              else {
                this.$ons.notification.toast('Cet email n\existe pas / Deze e-mail bestaat niet', {timeout: 2000});
              }
            });
        }
        else {
          this.$ons.notification.toast("Aucun email / Geen e-mail", {timeout: 2000})
        }
      },
      back() {
        EventBus.$emit('back');
      }
    }
  }
</script>


// WEBPACK FOOTER //
// Password.vue?fbfdfeac